import { FlexColumn, LabeledInput, MaterialIcon } from '@gorila-shared-ui/components';
import { useRecoilState } from 'recoil';
import { useStyles } from '../../../hooks/useStyles';
import { editingUserState } from '../../../storage/users';
import { userPasswordErrors } from '../../../utils/password';

export function UserPasswordForm() {
  const { theme } = useStyles();
  const [editingUser, setEditingUser] = useRecoilState(editingUserState);

  const onPasswordChange = (password: string) => {
    if (!editingUser) return;
    setEditingUser((prev) => ({ ...prev!, password, confirmPassword: '' }));
  };

  const onConfirmPasswordChange = (confirmPassword: string) => {
    if (!editingUser) return;
    setEditingUser((prev) => ({ ...prev!, confirmPassword }));
  };

  return (
    <FlexColumn>
      <LabeledInput
        label="Contraseña"
        placeholder={'Ingresa tu nueva contraseña'}
        value={editingUser?.password || ''}
        onChange={onPasswordChange}
        type="password"
        startEnhancer={
          <MaterialIcon
            name="lock"
            size="mini"
          />
        }
        error={!!editingUser?.password && userPasswordErrors(editingUser, 'errors')}
        required
      />
      <LabeledInput
        label="Repetir Contraseña"
        placeholder={'Confirma tu nueva contraseña'}
        value={editingUser?.confirmPassword || ''}
        onChange={onConfirmPasswordChange}
        type="password"
        startEnhancer={
          <MaterialIcon
            name="lock"
            size="mini"
            color={editingUser?.password ? theme.colors.contentPrimary : theme.colors.contentStateDisabled}
          />
        }
        disabled={!editingUser?.password}
        disabledViewOption
        error={!!editingUser?.confirmPassword && userPasswordErrors(editingUser, 'repeatPasswordErrors')}
        required
      />
    </FlexColumn>
  );
}
